module.exports = __webpack_public_path__ + "img/empty_state.a2610fcc.svg";